"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotAuctionSdk = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const gateway_1 = require("./gateway");
const config_1 = require("./config");
const contract_1 = require("./contract");
const stakefi_web3_1 = require("@ankr.com/stakefi-web3");
const polkadot_1 = require("./polkadot");
const isZeroAddress = address => address === '0x0000000000000000000000000000000000000000';
class SlotAuctionSdk {
    constructor(keyProvider, config = config_1.DEVELOP_CONFIG) {
        this.config = config;
        this.keyProvider = stakefi_web3_1.alwaysConnectedWeb3KeyProvider(keyProvider);
        this.polkadotProvider = new polkadot_1.PolkadotProvider({
            polkadotUrl: this.config.polkadotUrl,
            networkType: this.config.networkType,
        });
        this.apiGateway = new gateway_1.ApiGateway({
            baseUrl: config.baseUrl,
            cacheAge: config.cacheAge,
        });
    }
    getKeyProvider() {
        return this.keyProvider;
    }
    getApiGateway() {
        return this.apiGateway;
    }
    getPolkadotProvider() {
        return this.polkadotProvider;
    }
    isConnected() {
        return this.polkadotProvider.isConnected();
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            /*console.log(`Checking Web3 is connected`);
            if (!this.keyProvider.isConnected()) {
              await this.keyProvider.connectFromInjected(config);
            }*/
            console.log(`Checking PolkadotJS is connected`);
            yield this.polkadotProvider.connect();
        });
    }
    getAvailableCrowdloans() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            return this.apiGateway.getCrowdloans({
                network: currentNetwork,
            });
        });
    }
    getCrowdloansByStatus(status) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            return this.apiGateway.getCrowdloans({
                network: currentNetwork,
                status: status,
            });
        });
    }
    checkCrowdloanStatus(loanId, status) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.config.crowdloanStatusCheck)
                return;
            const crowdloan = yield this.getCrowdloanById(loanId);
            if (crowdloan.status !== status)
                throw new Error(`Incorrect crowdloan status, should be ${status} instead of ${crowdloan.status}`);
        });
    }
    getCrowdloanById(loanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            return this.apiGateway.getCrowdloanById({
                network: currentNetwork,
                loanId: loanId,
            });
        });
    }
    getPolkadotAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.polkadotProvider.getAccounts();
        });
    }
    getPolkadotBalance(account) {
        return __awaiter(this, void 0, void 0, function* () {
            const { free } = yield this.polkadotProvider.getAccountBalance(account);
            return free;
        });
    }
    getEthereumAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const keyProvider = yield this.injectedWeb3KeyProvider();
            return keyProvider.currentAccount();
        });
    }
    requestDepositAddress(loanId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.checkCrowdloanStatus(loanId, 'ONGOING');
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            const { address } = yield this.apiGateway.crowdloanDepositAddress({
                network: currentNetwork,
                loanId: loanId,
            });
            return address;
        });
    }
    depositFundsToCrowdloan(polkadotAccount, loanId, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.polkadotProvider.isConnected())
                throw new Error(`Polkadot must be connected`);
            yield this.checkCrowdloanStatus(loanId, 'ONGOING');
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            const { address } = yield this.apiGateway.crowdloanDepositAddress({
                network: currentNetwork,
                loanId: loanId,
            });
            const { extId, transactionHash, blockHash, } = yield this.polkadotProvider.sendFundsWithExtrinsic(polkadotAccount, address, amount);
            console.log(`Transaction is sent to block ${blockHash} with ext ${extId} and transaction hash ${transactionHash}`);
            const { id, status } = yield this.apiGateway.deposit({
                network: currentNetwork,
                extrinsic: extId,
            });
            console.log(`Deposits with id ${id} and status ${status}`);
        });
    }
    getCrowdloanBalances(polkadotAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            const { balances } = yield this.apiGateway.getCrowdloanBalances({
                network: currentNetwork,
                address: polkadotAccount,
            });
            return balances;
        });
    }
    claimRewardPoolTokens(polkadotAccount, loanId, ethereumAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.polkadotProvider.isConnected())
                throw new Error(`Polkadot must be connected`);
            yield this.checkCrowdloanStatus(loanId, 'SUCCEEDED');
            const keyProvider = yield this.injectedWeb3KeyProvider();
            if (!ethereumAddress) {
                ethereumAddress = keyProvider.currentAccount();
            }
            // calc claim amount
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            const { balances } = yield this.apiGateway.getCrowdloanBalances({
                network: currentNetwork,
                address: polkadotAccount,
                loanId: loanId,
            });
            const [balance] = balances.filter(b => b.loanId === loanId);
            if (!balance)
                throw new Error(`There is no balance for crowdloan ${loanId}`);
            const { total, claimable } = balance;
            console.log(`Current account balance for loan ${loanId} is: total=${total.toString(10)}, claimable=${claimable.toString(10)}`);
            if (claimable.isZero())
                throw new Error(`Claimable balance is zero`);
            // create signature
            const expirationTimestamp = new Date().getTime() + 10000 * 60; // 10 minutes (seconds);
            const sigOrToken64 = yield this.createRawTokenSignature(polkadotAccount, ethereumAddress, expirationTimestamp);
            // request crowdloan claim
            const { claim, tokenAddress } = yield this.apiGateway.crowdloanClaim({
                network: currentNetwork,
                address: polkadotAccount,
                ethAddress: ethereumAddress,
                amount: claimable,
                timestamp: expirationTimestamp,
                signature: sigOrToken64,
                loanId: loanId,
            });
            // claim tokens
            const contractManager = new contract_1.ContractManager(keyProvider, {
                rewardPoolAddress: tokenAddress,
            });
            const polkadotDecimals = this.polkadotProvider.calcDecimals();
            // aDOTp has the same scale factor as native polkadot tokens
            const scaledAmount = claim.data.amount.multipliedBy(Math.pow(10, polkadotDecimals)).toString(10);
            const { receiptPromise, transactionHash } = yield contractManager.claimTokensFor(claim.data.claimId, scaledAmount, claim.data.claimBeforeBlock, ethereumAddress, claim.data.signature);
            const transactionReceipt = yield receiptPromise;
            return { transactionReceipt, transactionHash };
        });
    }
    createRawTokenSignature(polkadotAccount, ethereumAddress, expirationTimestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.polkadotProvider.isConnected())
                throw new Error(`Polkadot must be connected`);
            const signMessage = Buffer.from(`StakeFi Signed Message:\n${polkadot_1.PolkadotProvider.extractPublicKeyHexFromAddress(polkadotAccount)}\n${ethereumAddress}\n${expirationTimestamp}`, 'ascii');
            console.log(`Signing raw message (ASCII): ${signMessage.toString('ascii')}`);
            console.log(`Signing raw message (HEX): ${signMessage.toString('hex')}`);
            return this.polkadotProvider.signRawMessage(polkadotAccount, `0x${signMessage.toString('hex')}`);
        });
    }
    createVerifiableTokenSignature(polkadotAccount, ethereumAddress, expirationTimestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.polkadotProvider.isConnected())
                throw new Error(`Polkadot must be connected`);
            const signature = yield this.createRawTokenSignature(polkadotAccount, ethereumAddress, expirationTimestamp);
            const tokenBase64 = Buffer.from([
                `polkadotAddress=${polkadotAccount}`,
                `ethereumAddress=${ethereumAddress}`,
                `expirationTimestamp=${expirationTimestamp}`,
                `signature=${signature}`
            ].join('&'), 'ascii').toString('base64');
            console.log(`New signature is: ${signature}`);
            console.log(`New token is: ${tokenBase64}`);
            return tokenBase64;
        });
    }
    getRewardPoolBalances(account) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            const crowdloans = yield this.getAvailableCrowdloans();
            const keyProvider = yield this.injectedWeb3KeyProvider();
            for (const c of crowdloans) {
                if (isZeroAddress(c.bondTokenContract)) {
                    continue;
                }
                const contractManager = new contract_1.ContractManager(keyProvider, {
                    rewardPoolAddress: c.bondTokenContract,
                });
                const balance = yield contractManager.getRewardPoolBalance(account);
                result.push({
                    loanId: c.loanId,
                    balance,
                });
            }
            return result;
        });
    }
    getRewardPoolBalance(loanId, account) {
        return __awaiter(this, void 0, void 0, function* () {
            const crowdloan = yield this.getCrowdloanById(loanId);
            if (isZeroAddress(crowdloan.bondTokenContract)) {
                return new bignumber_js_1.default('0');
            }
            const keyProvider = yield this.injectedWeb3KeyProvider();
            const contractManager = new contract_1.ContractManager(keyProvider, {
                rewardPoolAddress: crowdloan.bondTokenContract,
            });
            return contractManager.getRewardPoolBalance(account);
        });
    }
    getStakingTokenBalances(account) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            const crowdloans = yield this.getAvailableCrowdloans();
            const keyProvider = yield this.injectedWeb3KeyProvider();
            for (const c of crowdloans) {
                if (isZeroAddress(c.bondTokenContract)) {
                    continue;
                }
                const contractManager = new contract_1.ContractManager(keyProvider, {
                    rewardPoolAddress: c.bondTokenContract,
                });
                const balance = yield contractManager.getStakingTokenBalance(account);
                result.push({
                    loanId: c.loanId,
                    balance,
                });
            }
            return result;
        });
    }
    getStakingTokenBalance(loanId, account) {
        return __awaiter(this, void 0, void 0, function* () {
            const crowdloan = yield this.getCrowdloanById(loanId);
            if (isZeroAddress(crowdloan.bondTokenContract)) {
                return new bignumber_js_1.default('0');
            }
            const keyProvider = yield this.injectedWeb3KeyProvider();
            const contractManager = new contract_1.ContractManager(keyProvider, {
                rewardPoolAddress: crowdloan.bondTokenContract,
            });
            return contractManager.getStakingTokenBalance(account);
        });
    }
    getClaimableStakingRewards() {
        return __awaiter(this, void 0, void 0, function* () {
            const availableClaims = [];
            const currentNetwork = yield this.polkadotProvider.getNetworkType();
            const crowdloans = yield this.apiGateway.getCrowdloans({
                network: currentNetwork,
            });
            const keyProvider = yield this.injectedWeb3KeyProvider();
            const account = keyProvider.currentAccount();
            for (const crowdloan of crowdloans) {
                if (isZeroAddress(crowdloan.bondTokenContract)) {
                    continue;
                }
                const contractManager = new contract_1.ContractManager(keyProvider, {
                    rewardPoolAddress: crowdloan.bondTokenContract,
                });
                const rewards = yield contractManager.claimableRewardsOf(account);
                if (rewards.isZero()) {
                    continue;
                }
                availableClaims.push({
                    loanId: crowdloan.loanId,
                    amount: rewards,
                });
            }
            return availableClaims;
        });
    }
    getClaimMethodsForStakingRewards(loanId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.checkCrowdloanStatus(loanId, 'SUCCEEDED');
            const crowdloan = yield this.getCrowdloanById(loanId);
            if (isZeroAddress(crowdloan.bondTokenContract)) {
                return [];
            }
            const keyProvider = yield this.injectedWeb3KeyProvider();
            const contractManager = new contract_1.ContractManager(keyProvider, {
                rewardPoolAddress: crowdloan.bondTokenContract,
            });
            const claimMethods = [];
            const isTokenClaim = yield contractManager.isTokenClaim();
            if (isTokenClaim) {
                claimMethods.push('ERC20');
            }
            const isParachainClaim = yield contractManager.isParachainClaim();
            if (isParachainClaim) {
                claimMethods.push('PARACHAIN');
            }
            return claimMethods;
        });
    }
    claimStakingRewards(polkadotAccount, loanId, claimMethod) {
        return __awaiter(this, void 0, void 0, function* () {
            const crowdloan = yield this.getCrowdloanById(loanId);
            if (isZeroAddress(crowdloan.bondTokenContract)) {
                throw new Error(`Not available because bond contract is not set`);
            }
            const keyProvider = yield this.injectedWeb3KeyProvider();
            const contractManager = new contract_1.ContractManager(keyProvider, {
                rewardPoolAddress: crowdloan.bondTokenContract,
            });
            const availableClaimMethods = yield this.getClaimMethodsForStakingRewards(loanId);
            if (!claimMethod) {
                if (availableClaimMethods.length !== 1) {
                    throw new Error(`Unable to detect claim mode, please choose one of available: ${availableClaimMethods.join(', ')}`);
                }
                claimMethod = availableClaimMethods[0];
            }
            if (!availableClaimMethods.includes(claimMethod)) {
                throw new Error(`Not supported claim method: ${claimMethod}`);
            }
            let sendResult;
            if (claimMethod === 'ERC20') {
                sendResult = yield contractManager.claimTokenRewards();
            }
            else if (claimMethod === 'PARACHAIN') {
                sendResult = yield contractManager.claimParachainRewards(polkadotAccount);
            }
            else {
                throw new Error(`Not supported claim method: ${claimMethod}`);
            }
            const transactionReceipt = yield sendResult.receiptPromise;
            return { transactionReceipt, transactionHash: sendResult.transactionHash };
        });
    }
    injectedWeb3KeyProvider() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.keyProvider.isConnected()) {
                return this.keyProvider;
            }
            yield this.keyProvider.connectFromInjected();
            return this.keyProvider;
        });
    }
    addCrowdloanAssetsToMetaMask(loanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const keyProvider = yield this.injectedWeb3KeyProvider();
            const crowdloan = yield this.getCrowdloanById(loanId);
            if (!isZeroAddress(crowdloan.bondTokenContract)) {
                yield keyProvider.watchAsset({
                    type: 'ERC20',
                    address: crowdloan.bondTokenContract,
                    symbol: crowdloan.bondTokenSymbol,
                });
            }
            if (!isZeroAddress(crowdloan.rewardTokenContract)) {
                yield keyProvider.watchAsset({
                    type: 'ERC20',
                    address: crowdloan.rewardTokenContract,
                    symbol: crowdloan.rewardTokenSymbol,
                });
            }
        });
    }
}
exports.SlotAuctionSdk = SlotAuctionSdk;
//# sourceMappingURL=slot-auction.js.map